module.exports = __webpack_public_path__ + "img/newplaceholder.f9cd5a74.svg";